import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import client, { formatApiError } from "@/api/client";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ChangePasswordPage() {
  const { user, setUser } = useAuth();
  const [current, setCurrent] = useState("");
  const [newPw, setNewPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const isForced = user?.force_password_reset;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (newPw !== confirm) { setError("Passwords do not match"); return; }
    if (newPw.length < 6) { setError("Password must be at least 6 characters"); return; }
    setError(""); setLoading(true);
    try {
      await client.post("/auth/change-password", { current_password: current, new_password: newPw });
      // Refresh user to clear force_password_reset
      const meRes = await client.get("/auth/me");
      setUser(meRes.data);
      setSuccess(true);
      setTimeout(() => navigate("/"), 1500);
    } catch (err) { setError(formatApiError(err)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F8F9FA] p-8">
      <div className="w-full max-w-sm fade-in">
        <div className="mb-8">
          <div className="w-10 h-10 bg-[#006080] rounded-lg flex items-center justify-center mb-4"><span className="text-white font-black">X</span></div>
          <h2 className="text-2xl font-bold text-gray-900">{isForced ? "Set Your Password" : "Change Password"}</h2>
          <p className="text-gray-500 text-sm mt-1">
            {isForced ? "Your administrator has set a temporary password. Please set a new one to continue." : "Update your account password."}
          </p>
        </div>
        {isForced && (
          <div className="mb-4 p-3 rounded-md bg-amber-50 border border-amber-200 text-amber-700 text-sm">
            For security, you must change your password before continuing.
          </div>
        )}
        {error && <div className="mb-4 p-3 rounded-md bg-red-50 border border-red-200 text-red-700 text-sm">{error}</div>}
        {success ? (
          <div className="p-4 rounded-md bg-green-50 border border-green-200 text-green-700 text-sm">Password changed! Redirecting...</div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-5">
            <div className="space-y-1.5"><Label className="text-xs uppercase tracking-widest text-gray-500 font-semibold">Current Password</Label><Input type="password" value={current} onChange={e => setCurrent(e.target.value)} placeholder="Current password" required className="bg-white border-gray-200" /></div>
            <div className="space-y-1.5"><Label className="text-xs uppercase tracking-widest text-gray-500 font-semibold">New Password</Label><Input type="password" value={newPw} onChange={e => setNewPw(e.target.value)} placeholder="Min. 6 characters" required className="bg-white border-gray-200" /></div>
            <div className="space-y-1.5"><Label className="text-xs uppercase tracking-widest text-gray-500 font-semibold">Confirm New Password</Label><Input type="password" value={confirm} onChange={e => setConfirm(e.target.value)} placeholder="Repeat new password" required className="bg-white border-gray-200" /></div>
            <Button type="submit" className="w-full bg-[#006080] hover:bg-[#004d66] text-white font-semibold h-10" disabled={loading}>{loading ? "Saving..." : "Change Password"}</Button>
          </form>
        )}
        {!isForced && !success && <p className="mt-4 text-center text-sm"><button className="text-gray-400 hover:underline" onClick={() => navigate(-1)}>Cancel</button></p>}
      </div>
    </div>
  );
}
